


<div class="w3-container">


  <div  class="w3-modal" [ngStyle]="{ display: displayStyle ? 'block' : 'none' }">
    <div class="w3-modal-content w3-card-4 w3-animate-zoom" style="max-width:600px">

      <div class="w3-center"><br>
        
        <h2 class="mb-0">Login</h2>
      </div>
    

      <form class="w3-container" [formGroup]="loginform" (ngSubmit)="login(loginform.value)">
        <div class="w3-section">
          <label><b>Username & Email</b></label>
          <input placeholder="Enter your Email Or username" class="w3-input w3-border w3-margin-bottom" type="text"  [formControl]="emailControl" name="usrname"
            required>
          <label><b>Password</b></label>
          <input class="w3-input w3-border" type="password" placeholder="Enter Password" name="psw" formControlName="password" required>
          <button class="w3-button w3-block w3-green w3-section w3-padding" type="submit">Login</button>
          <!-- <input class="w3-check w3-margin-top" type="checkbox" checked="checked"> Remember me -->
        </div>
      </form>
      <div class="text-center my-2">
        <p class="m-0 new-size">New? <a href="/signup" class="signup-link">Sign-up - and start playing
            chess!</a></p>
      </div>
      <div class="w3-container w3-border-top w3-padding-16 ">
        <button (click)="closePopup()" type="button"
          class="w3-button w3-red">Cancel</button>
        <span class="w3-right w3-padding w3-hide-small">Forgot <a href="/login">password?</a></span>
      </div>

    </div>
  </div>
</div>